export default __webpack_public_path__ + "static/media/acceZ.dfba5002.svg";